import { useQuery } from 'react-query';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';

import { ITIL_TRANSLATION_TYPE_BY_SCOPE } from '../constants';
import type { ItilTranslationScope } from '../types';
import { fetchItilTranslationPreferApi } from '../translationCache';

type UseItilStoredTranslationOptions = {
  ticketId?: number;
  scope: ItilTranslationScope;
  enabled?: boolean;
};

export function useItilStoredTranslation({
  ticketId,
  scope,
  enabled = true
}: UseItilStoredTranslationOptions) {
  const { itilGenius } = useApiContext();
  const translationType = ITIL_TRANSLATION_TYPE_BY_SCOPE[scope];

  const query = useQuery(
    KEYS.itilGenius.translationByScope(ticketId, scope),
    () =>
      fetchItilTranslationPreferApi(
        itilGenius,
        ticketId!,
        scope,
        translationType
      ),
    {
      enabled: enabled && !!ticketId,
      refetchOnWindowFocus: false
    }
  );

  return {
    text: query.data ?? null,
    isFetched: query.isFetched
  };
}
